/* unplugin-vue-components disabled */import script from "./PBDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./PBDropdown.vue?vue&type=script&setup=true&lang=js"

import "./PBDropdown.vue?vue&type=style&index=0&id=19a5882d&lang=css"

const __exports__ = script;

export default __exports__